/* eslint-disable prettier/prettier */
import React, { useMemo } from 'react';
import * as ReactBootstrap from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import Wrapper from '../../../../../../../../shared/components/Wrapper';
import Table from '../../../../../../../../shared/components/Wrapper/Table';
import checkValue, {
  convertToReal,
} from '../../../../../../../../utils/values';
import ExportCsv from '../ExportCsv';
import ExportPdf from '../ExportPdf';

function UnifiedReportV2() {
  const accountingAppContext = useSelector(
    (reducer: IReducer) => reducer.accountingAppV2
  );

  const loading = useMemo(() => {
    if (accountingAppContext.isLoading) {
      return (
        <Wrapper.Default margin="20% 0 0 0" isActive>
          <ReactBootstrap.Spinner animation="border" />
        </Wrapper.Default>
      );
    }
    return <></>;
  }, [accountingAppContext.isLoading]);

  return (
    <>
      {loading}
      {!accountingAppContext.isLoading && (
        <>
          <Table.Default>
            <Table.Body>
              <Table.Column>
                <Table.Head />
                <Table.Head colSpan={2} color="#C5A66E">
                  Contas de Clientes
                </Table.Head>
                <Table.Head colSpan={2} color="#125C5B">
                  Contas da Fidúcia
                </Table.Head>
              </Table.Column>
              <Table.Column>
                <Table.SubHead>PARÂMETRO</Table.SubHead>
                <Table.SubHead>VALOR RECEBIDO</Table.SubHead>
                <Table.SubHead>VALOR ENVIADO</Table.SubHead>
                <Table.SubHead>VALOR RECEBIDO</Table.SubHead>
                <Table.SubHead>VALOR ENVIADO</Table.SubHead>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>Saldo inicial</Table.TInfo>
                <Table.Info color="#125C5B">
                  {convertToReal(
                    checkValue(accountingAppContext.terceiros.saldo_inicial)
                  )}
                </Table.Info>
                <Table.Info>-</Table.Info>
                <Table.Info color="#125C5B">
                  {convertToReal(
                    checkValue(accountingAppContext.fiducia.saldo_inicial)
                  )}
                </Table.Info>
                <Table.Info>-</Table.Info>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>TEDs</Table.TInfo>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.teds.valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.teds.valor_enviado
                    )
                  )}
                </Table.Info>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(accountingAppContext.fiducia.teds.valor_recebido)
                  )}
                </Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(accountingAppContext.fiducia.teds.valor_enviado)
                  )}
                </Table.Info>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>Pix</Table.TInfo>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(accountingAppContext.terceiros.pix.valor_enviado)
                  )}
                </Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.pix.valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(accountingAppContext.fiducia.pix.valor_recebido)
                  )}
                </Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(accountingAppContext.fiducia.pix.valor_enviado)
                  )}
                </Table.Info>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>Tarifas Pagas à Fiducia</Table.TInfo>
                <Table.Info>-</Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.tarifas_pagas_a_fiducia
                        .valor_enviado
                    )
                  )}
                </Table.Info>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.tarifas_pagas_a_fiducia
                        .valor_enviado
                    )
                  )}
                </Table.Info>
                <Table.Info>-</Table.Info>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>Tarifas Pagas à WL</Table.TInfo>
                <Table.Info color="#404040">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.tarifas_pagas_a_wl
                        .valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info color="#404040">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.tarifas_pagas_a_wl
                        .valor_enviado
                    )
                  )}
                </Table.Info>
                <Table.Info>-</Table.Info>
                <Table.Info>-</Table.Info>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>Tarifas pagas (PIX/TED/Outras)</Table.TInfo>
                <Table.Info>-</Table.Info>
                <Table.Info>-</Table.Info>
                <Table.Info>-</Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.tarifas_pagas.valor_enviado
                    )
                  )}
                </Table.Info>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>Tarifas pagas (TIB/SLB)</Table.TInfo>
                <Table.Info>-</Table.Info>
                <Table.Info>-</Table.Info>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.tarifas_tib_slb
                        .valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.tarifas_tib_slb.valor_enviado
                    )
                  )}
                </Table.Info>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>Pagamento de Contas Celcoin</Table.TInfo>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.pagamentos_celcoin
                        .valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.pagamentos_celcoin
                        .valor_enviado
                    )
                  )}
                </Table.Info>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.pagamentos_celcoin
                        .valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.pagamentos_celcoin
                        .valor_enviado
                    )
                  )}
                </Table.Info>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>FGTS</Table.TInfo>
                <Table.Info>-</Table.Info>
                <Table.Info>-</Table.Info>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(accountingAppContext.fiducia.fgts.valor_recebido)
                  )}
                </Table.Info>
                <Table.Info>-</Table.Info>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>Investimento</Table.TInfo>
                <Table.Info>-</Table.Info>
                <Table.Info>-</Table.Info>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.investimento.valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info>-</Table.Info>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>Recebimento de TEV Interna</Table.TInfo>
                <Table.Info>
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.recebimento_tev_interna
                        .valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info>
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.recebimento_tev_interna
                        .valor_enviado
                    )
                  )}
                </Table.Info>
                <Table.Info>
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.recebimento_tev_interna
                        .valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info>
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.recebimento_tev_interna
                        .valor_enviado
                    )
                  )}
                </Table.Info>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>Domicílio Bancário</Table.TInfo>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.domicilio_bancario
                        .valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info>-</Table.Info>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.domicilio_bancario
                        .valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info>-</Table.Info>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>Boletos</Table.TInfo>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.boletos_liquidados
                        .valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.boletos_liquidados
                        .valor_enviado
                    )
                  )}
                </Table.Info>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.boletos_liquidados
                        .valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.boletos_liquidados
                        .valor_enviado
                    )
                  )}
                </Table.Info>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>TEVs</Table.TInfo>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.tev_entre_ambiente
                        .valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.tev_entre_ambiente
                        .valor_enviado
                    )
                  )}
                </Table.Info>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.tev_entre_ambiente
                        .valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.tev_entre_ambiente
                        .valor_enviado
                    )
                  )}
                </Table.Info>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>Cartão</Table.TInfo>
                <Table.Info color="#000">-</Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.cartao.valor_enviado
                    )
                  )}
                </Table.Info>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.cartao.valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.cartao.valor_enviado
                    )
                  )}
                </Table.Info>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>Cripto</Table.TInfo>
                <Table.Info color="#000">-</Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.terceiros.cripto.valor_enviado
                    )
                  )}
                </Table.Info>
                <Table.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.cripto.valor_recebido
                    )
                  )}
                </Table.Info>
                <Table.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      accountingAppContext.fiducia.cripto.valor_enviado
                    )
                  )}
                </Table.Info>
              </Table.Column>
              <Table.Column>
                <Table.TInfo>Saldo Final</Table.TInfo>
                <Table.Info color="#125C5B">
                  {convertToReal(
                    checkValue(accountingAppContext.terceiros.saldo_final)
                  )}
                </Table.Info>
                <Table.Info>-</Table.Info>
                <Table.Info color="#125C5B">
                  {convertToReal(
                    checkValue(accountingAppContext.fiducia.saldo_final)
                  )}
                </Table.Info>
                <Table.Info>-</Table.Info>
              </Table.Column>
            </Table.Body>
          </Table.Default>
          <Table.Action>
            <Table.TextAction>
              Total saldo unificado:{' '}
              {convertToReal(
                checkValue(
                  accountingAppContext.terceiros.saldo_final +
                    accountingAppContext.fiducia.saldo_final
                )
              )}
            </Table.TextAction>
            <Table.ButtonContainer>
              <ExportCsv
                data={accountingAppContext}
                title="CSV Relatório Unificado"
              />
              <ExportPdf
                data={accountingAppContext}
                title="PDF Relatório Unificado"
              />
            </Table.ButtonContainer>
          </Table.Action>
        </>
      )}
    </>
  );
}

export default UnifiedReportV2;
